// extracted by mini-css-extract-plugin
export default {"active":"menu_active__qEh3o"};